import { useContext } from 'react'
import { AuthContext } from './AuthContext'

// 业务组件统一从这里取 auth state / action。
// 未挂 AuthProvider 时直接抛,避免 silent null deref。
export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within <AuthProvider>')
  return ctx
}
